import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TypeOfTableData } from '../../pricing-simulator/types/generic-table.model';
import { filterColumnsForToggleView } from '../../pricing-simulator/utils/column-utils';
import { ISummaryState } from '../types/summary-state.model';
import {
  getSummaryData,
  getPPGLevelImpactData
} from './simulation-summary-slice';

const initialState: ISummaryState = {
  isFetchingSummaryMetadata: false,
  summaryMetrics: {
    metrics: [],
    modules: [],
    summary_strip_data: {}
  },
  ppgLevelImpactData: {
    inputCols: [],
    rows: []
  },
  fetchingPPGLevelImpactData: false,
  isUnitSelected: false,
  isPlotSelected: false
};

const summarySlice = createSlice({
  name: 'summary-slice',
  initialState,
  reducers: {
    handleToggleValueChange(
      state,
      action: PayloadAction<{
        isUnitSelected: boolean;
      }>
    ) {
      state.isUnitSelected = action.payload.isUnitSelected;
    },
    handleToggleViewChange(
      state,
      action: PayloadAction<{
        isPlotSelected: boolean;
      }>
    ) {
      state.isPlotSelected = action.payload.isPlotSelected;
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getSummaryData.pending, (state) => {
        state.isFetchingSummaryMetadata = true;
        state.summaryMetrics = {
          metrics: [],
          modules: [],
          summary_strip_data: {}
        };
      })
      .addCase(getSummaryData.fulfilled, (state, action) => {
        state.isFetchingSummaryMetadata = false;
        state.summaryMetrics = action.payload;
      })
      .addCase(getSummaryData.rejected, (state) => {
        state.isFetchingSummaryMetadata = false;
        state.summaryMetrics = {
          metrics: [],
          modules: [],
          summary_strip_data: {}
        };
      })
      .addCase(getPPGLevelImpactData.rejected, (state) => {
        state.fetchingPPGLevelImpactData = false;
        state.ppgLevelImpactData = {
          inputCols: [],
          rows: []
        };
      })
      .addCase(getPPGLevelImpactData.pending, (state) => {
        state.fetchingPPGLevelImpactData = true;
        state.ppgLevelImpactData = {
          inputCols: [],
          rows: []
        };
      })
      .addCase(getPPGLevelImpactData.fulfilled, (state, action) => {
        state.fetchingPPGLevelImpactData = false;
        state.ppgLevelImpactData = action.payload;
        state.ppgLevelImpactData.inputCols = filterColumnsForToggleView(
          [TypeOfTableData.DISPLAY],
          action.payload.columns,
          ''
        );
        state.ppgLevelImpactData.rows = action.payload.row;
        state.ppgLevelImpactData.footer = action.payload.footer;
      })
});

export const { handleToggleValueChange, handleToggleViewChange } =
  summarySlice.actions;

export default summarySlice;
